<script>
import { Line, mixins } from 'vue-chartjs';
// const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    chartOrigin: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default: null
    },
    chartOpt: {
      type: Object,
      default: null
    },
  },

  mounted() {
    this.renderChart(this.chartData, this.chartOpt);
  },

  // data() {
  //   return {
  //     chartOption: {
  //       responsive: true,
  //       maintainAspectRatio: false,
  //       legend: {
  //         display: true,
  //       },
  //       plugins: {
  //         legend: {
  //           labels: {
  //             font: {
  //               size: 14
  //             }
  //           }
  //         },
  //         title: true
  //       },
  //       scales: {
  //         xAxes: [{ stacked: true }],
  //         yAxes: [{
  //           ticks: {
  //             callback: function(value, index, ticks) {
  //               console.log('this.chartOrigin', this.chartOrigin)
  //               if (this.chartOrigin !== 'se_basic') {
  //                 let showLabel;
  //                 switch (value) {
  //                   case 4:
  //                     showLabel = "嚴重"
  //                     break;
  //                   case 3:
  //                     showLabel = "中等"
  //                     break;
  //                   case 2:
  //                     showLabel = "輕微"
  //                     break;
  //                   case 1:
  //                     showLabel = "沒有"
  //                     break;
  //                   default:
  //                     break;
  //                 }
  //                 return showLabel;
  //               }
  //             },
  //             // display: true
  //           },
  //           stacked: false,
  //         }]
  //       },
  //     },
  //   }
  // }
}

</script>

<!-- <style>
</style> -->